import gql from 'graphql-tag';

export const setDefaultChannelMutation = gql(`
  mutation setDefaultChannel($channelId: UUID!) {
    me {
      setDefaultChannel(channelId: $channelId)
    }
  }
`);
